import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18next
    .use(initReactI18next) // Allow us to use hooks in functional components
    .use(HttpApi) // Registering the back-end plugin
    .init({
        lng: 'en',
        whitelist: ['en', 'fr', 'es'],
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true
        },
        debug: __GABI_ENV__ === 'development',
    });

export default i18next;
